import { Component, OnInit, ViewChildren } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import { DateTimePipe } from 'src/app/shared/pipe/date.pipe';
import { map } from 'rxjs/operators';
import { DashboardService } from 'src/app/modules/dashboard-admin/dashboard.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.scss'],
})
export class DashboardAdminComponent implements OnInit {
  @ViewChildren('allcanvas') myCharts: any;

  checked: boolean = false;
  isLoading: boolean = false;
  firstDay: Date;
  lastDay: Date;
  dateTime = [];
  selectAllDate: boolean = false;
  result;
  alldata;
  count: number = 0;
  alllabels = [];
  data_chart = [];
  wait4data = [];
  myChart1;
  myChart2;
  myChart3;
  myChart4;
  // alldata = {
  //   firstrow: {
  //     date: '2022-01-31',
  //     num_user: 25,
  //     num_fb: 100,
  //     userperday: 125,
  //     percen: 25,
  //     num_admin: 3,
  //     num_teacher: 3,
  //     num_psy: 3,
  //     normal_user: 26,
  //     prem_user: 99,
  //   },
  //   secondrow: {
  //     type: 'revenue',
  //     allrevenue: [
  //       {
  //         category: 'คอร์สเรียน',
  //         value: 680000000,
  //       },
  //       {
  //         category: 'workshop',
  //         value: 60000000,
  //       },
  //       {
  //         category: 'consult',
  //         value: 14800000,
  //       },
  //       {
  //         category: 'แบบทดสอบ',
  //         value: 10000000,
  //       },
  //     ],
  //     allwait: [
  //       {
  //         category: 'คอร์สเรียน',
  //         value: 8000000,
  //       },
  //       {
  //         category: 'workshop',
  //         value: 600000,
  //       },
  //       {
  //         category: 'consult',
  //         value: 1480000,
  //       },
  //       {
  //         category: 'แบบทดสอบ',
  //         value: 1000000,
  //       },
  //     ],
  //   },
  //   the_rest: {
  //     courses_num: 4,
  //     course_register: 110000,
  //     consult_num: 4,
  //     consult_register: 794,
  //     workshop_num: 124,
  //     workshop_register: 1800,
  //     test_num: 5,
  //     test_participant: 21000,
  //     research_num: 2,
  //     research_participant: 3333,
  //     news_num: 2,
  //     news_reader: 3333,
  //     article_num: 15,
  //     article_reader: 25860,
  //   },
  // };

  constructor(
    private DashboardService: DashboardService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    Chart.register(...registerables);

    let date = new Date();
    this.firstDay = new Date(date.getFullYear(), date.getMonth(), 1, 9);
    this.lastDay = new Date();
    this.dateTime = [this.firstDay, this.lastDay];
    this.gobalFunctionService.setTitle('Dashboard');

    let data = {
      FROM_DATE: this.firstDay.toISOString().slice(0, 10),
      TO_DATE: this.lastDay.toISOString().slice(0, 10),
      ALL_DATA: false,
    };

    this.DashboardService.getAllDashBoard(data)
      .pipe(
        map((res) => {
          this.alldata = res.result;
          this.resultNum();

          for (let i = 0; i < this.alldata.secondrow.allrevenue.length; i++) {
            this.alllabels.push(this.alldata.secondrow.allrevenue[i].category);
            this.data_chart.push(this.alldata.secondrow.allrevenue[i].value);
            this.wait4data.push(this.alldata.secondrow.allwait[i].value);
          }
        })
      )
      .subscribe();
  }
  ngAfterViewInit() {
    this.myChart1 = new Chart('RevenueChart', {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: this.data_chart,
            backgroundColor: ['#ff4c5a', '#ff6d64', '#ffac79', '#ffc979'],
            hoverOffset: 4,
          },
        ],
      },
      options: {
        font: {
          family: 'Sarabun',
        },
        responsive: true,
      },
    });
    this.myChart2 = new Chart('Wait4payChart', {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: this.wait4data,
            backgroundColor: ['#ff4c5a', '#ff6d64', '#ffac79', '#ffc979'],
            hoverOffset: 4,
          },
        ],
      },
      options: {
        font: {
          family: 'Sarabun',
        },
        responsive: true,
      },
    });
    this.myChart3 = new Chart('RevenueChartIpad', {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: this.data_chart,
            backgroundColor: ['#ff4c5a', '#ff6d64', '#ffac79', '#ffc979'],
            hoverOffset: 4,
          },
        ],
      },
      options: {
        font: {
          family: 'Sarabun',
        },
        responsive: true,
      },
    });
    this.myChart4 = new Chart('Wait4payChartIpad', {
      type: 'doughnut',
      data: {
        datasets: [
          {
            data: this.wait4data,
            backgroundColor: ['#ff4c5a', '#ff6d64', '#ffac79', '#ffc979'],
            hoverOffset: 4,
          },
        ],
      },
      options: {
        font: {
          family: 'Sarabun',
        },
        responsive: true,
      },
    });
  }

  selectDate() {
    this.count++;
    let date = new Date();
    let fromdate = new Date(new Date(this.dateTime[0]).setHours(9));
    let todate = new Date(new Date(this.dateTime[1]).setHours(9));

    let data = {
      FROM_DATE: fromdate,
      TO_DATE: todate,
      ALL_DATA: false,
    };

    if (this.count % 2 === 1) { //เช็คว่ายิง 2 ครั้ง ให้ยิงครั้งเดียว
      this.DashboardService.getAllDashBoard(data)
        .pipe(
          map((res) => {
            // console.log(res.result);
            this.alldata = res.result;
            this.resultNum();
            // console.log(this.alldata);

            this.data_chart = [];
            this.wait4data = [];

            for (let i = 0; i < this.alldata.secondrow.allrevenue.length; i++) {
              this.data_chart.push(this.alldata.secondrow.allrevenue[i].value);
              this.wait4data.push(this.alldata.secondrow.allwait[i].value);
            }
            // console.log(this.data_chart);
            this.myChart1.data.datasets[0].data = this.data_chart;
            this.myChart2.data.datasets[0].data = this.wait4data;
            this.myChart3.data.datasets[0].data = this.data_chart;
            this.myChart4.data.datasets[0].data = this.wait4data;
            this.myChart1.update();
            this.myChart2.update();
            this.myChart3.update();
            this.myChart4.update();
          })
        )
        .subscribe();
    }
  }
  checkboxed() {
    this.selectAllDate = !this.selectAllDate;
    if (this.selectAllDate == true) {
      this.dateTime = null;
      let data = {
        FROM_DATE: this.firstDay.toISOString().slice(0, 10),
        TO_DATE: this.lastDay.toISOString().slice(0, 10),
        ALL_DATA: true,
      };
      // console.log(data);

      this.DashboardService.getAllDashBoard(data)
        .pipe(
          map((res) => {
            // console.log(res.result);
            this.alldata = res.result;
            this.resultNum();
            // console.log(this.alldata);

            this.data_chart = [];
            this.wait4data = [];

            for (let i = 0; i < this.alldata.secondrow.allrevenue.length; i++) {
              this.data_chart.push(this.alldata.secondrow.allrevenue[i].value);
              this.wait4data.push(this.alldata.secondrow.allwait[i].value);
            }
            this.myChart1.data.datasets[0].data = this.data_chart;
            this.myChart2.data.datasets[0].data = this.wait4data;
            this.myChart3.data.datasets[0].data = this.data_chart;
            this.myChart4.data.datasets[0].data = this.wait4data;
            this.myChart1.update();
            this.myChart2.update();
            this.myChart3.update();
            this.myChart4.update();
          })
        )
        .subscribe();
    } else {
      this.dateTime = [this.firstDay, this.lastDay];
      let data = {
        FROM_DATE: this.firstDay.toISOString().slice(0, 10),
        TO_DATE: this.lastDay.toISOString().slice(0, 10),
        ALL_DATA: false,
      };

      this.DashboardService.getAllDashBoard(data)
        .pipe(
          map((res) => {
            // console.log(res.result);
            this.alldata = res.result;
            this.resultNum();
            // console.log(this.alldata);

            this.data_chart = [];
            this.wait4data = [];

            for (let i = 0; i < this.alldata.secondrow.allrevenue.length; i++) {
              this.data_chart.push(this.alldata.secondrow.allrevenue[i].value);
              this.wait4data.push(this.alldata.secondrow.allwait[i].value);
            }
            this.myChart1.data.datasets[0].data = this.data_chart;
            this.myChart2.data.datasets[0].data = this.wait4data;
            this.myChart3.data.datasets[0].data = this.data_chart;
            this.myChart4.data.datasets[0].data = this.wait4data;
            this.myChart1.update();
            this.myChart2.update();
            this.myChart3.update();
            this.myChart4.update();
          })
        )
        .subscribe();
    }
  }
  tofixed(num) {
    return num.toFixed(2);
  }
  commaTs(num) {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  formattedDate(date) {
    let formattedDate = new DateTimePipe().transform(date, 'FullNoTime');
    return formattedDate;
  }
  resultNum() {
    // let num = this.alldata.firstrow.percen.replace('%', '');
    if (this.alldata.firstrow.percen > 0) {
      this.result = 'increase';
    } else if (
      this.alldata.firstrow.percen === 0 ||
      !this.alldata.firstrow.percen
    ) {
      this.result = 'same';
    } else if (this.alldata.firstrow.percen < 0) {
      this.result = 'decrease';
    }
    // console.log(this.result);
  }
}
